/**
 *
 * Asynchronously loads the component for Unauthorized
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
